import { useRadio } from "@/context/RadioContext";
import { REACTIONS } from "@/lib/api";

export const ReactionChips = ({ className = "" }) => {
  const { state, react, playing } = useRadio();
  const cur = state?.current;
  if (!cur) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="reaction-chips">
      {REACTIONS.map((r) => {
        const on = cur.my_reactions.includes(r);
        return (
          <button
            key={r}
            data-testid={`reaction-chip-${r}`}
            disabled={!playing}
            onClick={() => react(r)}
            className={`rounded-full border px-3 py-1.5 font-mono text-[11px] uppercase tracking-widest transition-[background-color,border-color,color,transform] duration-200 hover:-translate-y-0.5 disabled:opacity-40
              ${on ? "border-[#00F5D4] bg-[#00F5D4] text-[#07090E]" : "border-white/15 text-slate-300 hover:border-[#00F5D4]/70"}`}
          >
            {r} <span className="opacity-70">{cur.reactions[r] || 0}</span>
          </button>
        );
      })}
    </div>
  );
};
